<div class="registry registry__details__main">
    <header class="registry__header header">
        <div class="header__section">
            <div *ngIf="organization?.logo" class="logo-container">
                <img class="header__logo" [src]="organization?.logo" alt="Company logo" />
            </div>
            <div class="header__logo-default" *ngIf="!organization?.logo">
                <cm-icon name="company-logo-placeholder" class="placeholder-img"></cm-icon>
            </div>
            <div class="header__organization-info" *ngIf="!isDesktop">
                <h2 class="prof-header prof-header--level-4">{{ organization.name }}</h2>
                <p class="header__subtitle">The registry</p>
            </div>
        </div>
        <button class="btn close-btn" *ngIf="!isDesktop" (click)="onBackClick()"></button>
    </header>
    <h2 class="full-name-block">{{ professionalFullName }}</h2>
    <div class="entries-block">
        <cm-public-block-element
            class="entry"
            *ngFor="let entry of entries"
            [recordView]="true"
            [entry]="entry"
            [hideDetailsBtn]="true"
            [ignoreHideFilter]="true"
        >
        </cm-public-block-element>
    </div>
    <h4 *ngIf="!showedAll" class="cm-link bold mt-2 mb-4" (click)="showAll()">
        SHOW ALL RESULTS FOR {{ professionalFullName.toLocaleUpperCase() }}
    </h4>
</div>
<footer class="footer">
    <button class="btn btn-default registry__back-btn" (click)="onBackClick()">Back</button>
    <button class="btn btn-primary registry__back-btn" (click)="print()">Print</button>
</footer>
<cm-report-print-export-options class="hide" entityName="" [reportQuery]="reportQuery">
</cm-report-print-export-options>
